// apps/client/src/game/commands/chat.ts (M0-T19, §8.7) — say a line to the town, play an emote
import { tuning, type EmoteId } from '@whiskerton/content';
import { useGame } from '../../state/store';
import type { CommandFactory } from '../game';

export interface ChatCommands { say(text: string): Promise<boolean>; emote(e: EmoteId): void }
// eslint-disable-next-line @typescript-eslint/no-empty-object-type -- declaration merging into GameCommands
declare module '../game' { interface GameCommands extends ChatCommands {} }

export const commands: CommandFactory<ChatCommands> = (game) => ({
  async say(text) {
    const clean = text.replace(/\s+/g, ' ').trim();
    if (!clean) return false;
    if ([...clean].length > tuning.net.chatMaxChars) { useGame.getState().toast('chat.tooLong', { max: tuning.net.chatMaxChars }, 'warn'); return false; }
    return (await game.cmd.act('chat.say', { text: clean })).ok;
  },
  emote(emote) {
    const me = game.you();
    void game.cmd.act('emote.play', { emote }, { optimistic: () => {
      me?.avatar.play(emote);
      const r = useGame.getState().you?.resident;
      if (me && r) useGame.getState().emoteShow(r, emote, game.now());
      return () => {};
    } });
  },
});
